import { useState, useEffect } from 'react';
import {
  handleResponseStatus,
  sendRequest,
  initialQuery,
} from '../utils/api-request';
import getConfig from '../config';
import {
  REGISTER_STATUS,
  ACTIVE_STATUS,
  PAUSED_STATUS,
  CLOSED_STATUS,
  FAILED_STATUS,
  TERMINATED_STATUS,
} from '../constans/constans';

const { indexerApi } = getConfig();

const useAccountProjects = (accountId, filterQuery, activeSort, currentPage, pageSize = 20) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [projectsList, setProjectsList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [defaultBody] = useState({
    ...initialQuery,
    query: {
      bool: {
        must: [
          {
            match: {
              'signer_id.keyword': accountId,
            },
          },
        ],
      },
    },
  });

  const getTotalCount = (data) => {
    const total = data?.hits?.total;
    if (typeof total === 'number') return total;
    if (total && typeof total.value === 'number') return total.value;
    if (typeof data?.total === 'number') return data.total;
    return 0;
  };

  const setProjects = (data) => {
    setIsError(false);
    if (data?.hits?.hits) {
      setProjectsList([...data.hits.hits]);
      setTotalCount(getTotalCount(data));
    } else {
      setProjectsList([]);
      setTotalCount(0);
    }
  };

  const showError = () => {
    setIsError(true);
    setProjectsList([]);
    setTotalCount(0);
  };

  const fetchProjects = async (filter, sort, page) => {
    let body = {};

    if (filter?.length) {
      const updBody = structuredClone(defaultBody);
      const mustQuery = [...updBody.query.bool.must, ...filter];
      updBody.query.bool.must = mustQuery;
      body = updBody;
    } else body = defaultBody;

    const statusSort = {
      _script: {
        type: 'number',
        order: sort?.key === 'status.keyword' ? sort.value : 'asc',
        script: {
          lang: 'painless',
          params: {
            order: {
              [REGISTER_STATUS]: 0,
              [ACTIVE_STATUS]: 1,
              [PAUSED_STATUS]: 2,
              [CLOSED_STATUS]: 3,
              [FAILED_STATUS]: 4,
              [TERMINATED_STATUS]: 5,
            },
          },
          source: `
            def status = doc['status.keyword'].size() == 0 ? '' : doc['status.keyword'].value.toLowerCase();
            return params.order.containsKey(status) ? params.order[status] : 999;
          `,
        },
      },
    };

    if (sort?.key === 'status.keyword') {
      body.sort = [
        statusSort,
        { 'project_id.keyword': { order: 'desc', unmapped_type: 'keyword' } },
      ];
    } else {
      body.sort = [{ [sort.key]: sort.value }];
    }
    body.from = (page - 1) * pageSize;
    body.size = pageSize;

    const result = await sendRequest(indexerApi, 'POST', JSON.stringify(body));
    return result;
  };

  const initialize = async (page) => {
    setIsLoading(true);
    const { result, statusCode } = await fetchProjects(filterQuery, activeSort, page);
    handleResponseStatus(
      statusCode,
      () => setProjects(result),
      () => showError(),
    );
    setIsLoading(false);
  };

  useEffect(() => {
    if (!accountId) {
      setProjectsList([]);
      setTotalCount(0);
      setIsLoading(false);
      return;
    }
    initialize(currentPage);
  }, [filterQuery, activeSort, currentPage, pageSize, accountId]);

  return {
    isLoading,
    isError,
    projectsList,
    totalCount,
    refreshList: () => initialize(currentPage),
  };
};

export default useAccountProjects;
